import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { errorCheck } from '@root/utils/error-check';
import { map } from 'rxjs/operators';
import { HttpService } from '@services/http.service';
import { select, Store } from '@ngrx/store';
import * as loginReducers from '@modules/login/reducers';
import * as adminReducer from '@modules/super-admin/reducers';

@Injectable({
  providedIn: 'root'
})
export class MerchantDetailService {
  user: any;

  public user$ = this.store.pipe(select(loginReducers.getUser));

  constructor(
    protected http: HttpService,private store: Store<adminReducer.State>,
  ) {
    this.user$.subscribe((user) => {
      this.user = user;
    });
  }

  getMerchantDetail(params) {
    // we will use HttpClient module instead of rxjs/ajax
    // to use angular http interceptor for auth token.
    return this.http.get(`${environment.API_URL}/api/merchants`, params)
      .pipe(
        map(res => errorCheck(res)),
        map(
        res => res.result,
        error => { throw error; }
        )
      );
  }

  getSAmerchants(params) {
    // we will use HttpClient module instead of rxjs/ajax
    // to use angular http interceptor for auth token.
    return this.http.get(`${environment.API_URL}/api/merchants/getSAmerchants`, params)
      .pipe(
        map(res => errorCheck(res)),
        map(
        res => res.result.map(i=>{ //filter and added commision value to result array compared to the resultObj array on the base of SAreferenceNumber
          i.commission = 0;
          i.totalEarning = 0;
          i.commissionPercent = this.user.commissionPercent;
          // const SAmerchantReferenceNumber = i.SAmerchantReferenceNumber;
          // Check if the "SAmerchantReferenceNumber" exists in the "resultObj" object
          // if (res.resultObj[SAmerchantReferenceNumber] !== undefined) {
            // Update the "commission" & "totalEarning" fields in the result
            // i.totalEarning = res.resultObj[SAmerchantReferenceNumber].toFixed(2);
            // i.commission = (res.resultObj[SAmerchantReferenceNumber]*(i.commissionPercent ? i.commissionPercent : 0)/100).toFixed(2);
          // }
          return i
      }),
        error => { throw error; }
        )
      );
  }

  getUserDetail(params) {
    // we will use HttpClient module instead of rxjs/ajax
    // to use angular http interceptor for auth token.
    return this.http.get(`${environment.API_URL}/api/user`, params)
      .pipe(
        map(res => errorCheck(res)),
        map(
        res => res.result,
        error => { throw error; }
        )
      );
  }

  getSAMerchantById(params) {
    return this.http.post(`${environment.API_URL}/api/merchants/getSAMerchantById`,params).pipe(
      map(res => errorCheck(res)),
      map(
      res => res.result,
      error => { throw error; }
      )
    );
  }


  deactivateMerchant(params) {
    console.log(params)
    // we will use HttpClient module instead of rxjs/ajax
    // to use angular http interceptor for auth token.
    return this.http.delete(`${environment.API_URL}/api/merchants/deactivateMercahnt/${params.id}`)
      .pipe(
        map(res => errorCheck(res)),
        map(
        res => res.result,
        error => { throw error; }
        )
      );
  }

  getMerchantStatistics() {
    return this.http.get(`${environment.API_URL}/api/merchants/statistics`)
      .pipe(
        map(res => errorCheck(res)),
        map(
          res => res.result,
          error => { throw error; }
        )
      );
  }
  getSAstatistics() {
    return this.http.get(`${environment.API_URL}/api/merchants/getSAstatistics`)
      .pipe(
        map(res => errorCheck(res)),
        map(
          res => res.result,
          error => { throw error; }
        )
      );
  }

 deleteMerchant( email: any ) {
  return this.http.post(
    `${environment.API_URL}/api/merchants/deleteMerchant`, email
  ).pipe(
    map(res => errorCheck(res)),
    map(res => res.result,
      error => { throw error; }
    )
  );
}
  
}
